<template>
  <div class="alert fade show" :class="notificationTypeClass">
    <div class="alert-icon text-white" v-if="notificationIconName">
      <BaseIcon :type="notificationIconType" :icon="notificationIconName" size="2x" />
    </div>
    <div
      class="alert-text text-white"
      v-if="!notification.allowHTML">{{ notification.message }}</div>
    <div
      class="alert-text text-white"
      v-if="notification.allowHTML"
      v-html="notification.message"></div>
    <div class="alert-close" @click="closeNotification">
      <BaseIcon type="fas" icon="times" size="1x" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationBarItem',
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  computed: {
    notificationTypeClass () {
      return `alert-${this.notification.type}`
    },
    notificationIconName () {
      return this.notification.iconName
    },
    notificationIconType () {
      return this.notification.iconType || 'fas'
    },
    notificationDelay () {
      return this.notification.delay
    }
  },
  methods: {
    closeNotification () {
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss" scoped>
.alert {
  cursor: pointer;
}
</style>
